// Copyright 2024 - MinIO, Inc. All rights reserved.
import { createSlice } from "@reduxjs/toolkit";
import { getHealthAsync } from "./healingThunks";
import { ApiError } from "../../../api/observeApi";
import { CAServerDrive, ClusterAnalysis } from "../../DataMap/types";
import { LoadingStatus } from "common/types";

export interface HealingState {
  loadingAnalysis: LoadingStatus;
  error: ApiError | null;
  analysis: ClusterAnalysis | null;
  drivesHealing: CAServerDrive[];
}

const initialState: HealingState = {
  loadingAnalysis: "neverLoaded",
  error: null,
  analysis: null,
  drivesHealing: [],
};

export const healingSlice = createSlice({
  name: "healing",
  initialState,
  reducers: {
    resetHealing: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getHealthAsync.pending, (state, action) => {
        state.loadingAnalysis = "loading";
        state.error = null;
      })
      .addCase(getHealthAsync.rejected, (state, action) => {
        state.loadingAnalysis = "failed";
        if (action.payload) {
          // let payload: FetchError = action.payload
          state.error = action.payload as ApiError;
        }
      })
      .addCase(getHealthAsync.fulfilled, (state, action) => {
        state.loadingAnalysis = "idle";
        state.analysis = action.payload!;
        if (action.payload) {
          if (
            action.payload.minio &&
            action.payload.minio.info &&
            action.payload.minio.info.servers
          ) {
            const servers = action.payload.minio.info.servers;
            const drivesHealing: CAServerDrive[] = [];
            servers.forEach((srv) =>
              srv.drives?.forEach((drv) => {
                if (drv.healing) {
                  drivesHealing.push(drv);
                }
              }),
            );
            state.drivesHealing = drivesHealing;
          }
        }
      });
  },
});

export const { resetHealing } = healingSlice.actions;
export default healingSlice.reducer;
